@if(item.navCap){ @if(item.divider){ <span class="sidebar-divider"></span>}
<div mat-subheader class="nav-caption" [class.nav-caption--brand]="item.navCapBrand">
  {{ item.navCap }}
</div>
} @if(!item.navCap && !item.twoLines) {
@if(item.children?.length) {
<a
  mat-list-item
  href="#"
  (click)="handleParentNavClick(item, $event)"
  [ngClass]="{
    activeMenu: isNavIconActive(item),
    expanded: expanded,
    activemenu: isChildActive(item),
    disabled: item.disabled
  }"
  class="menu-list-item"
>
  @if(item.iconName){
  <app-nav-icon-pair
    matListItemIcon
    class="routeIcon"
    [class.sub-item-icon]="!!item.subItemIcon"
    [icon]="item.iconName"
    [active]="isNavIconActive(item)"
    iconClass="routeIcon"
  />
  }
  <span class="hide-menu">{{ item.displayName | translate }}</span>

  <span class="arrow-icon" fxFlex>
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
      expand_more
    </mat-icon>
  </span>
  @if(item.chip) {
  <span>
    <span class="{{ item.chipClass }} px-2 py-1 item-chip font-medium rounded-full">{{ item.chipContent }}</span>
  </span>
  }
</a>
} @else if(item.route) {
<button
  type="button"
  mat-list-item
  (click)="navigateLeaf(item, $event)"
  [disabled]="!!item.disabled"
  [ngClass]="{
    activeMenu: isNavIconActive(item),
    expanded: expanded,
    activemenu: isChildActive(item),
    disabled: item.disabled
  }"
  class="menu-list-item !border-0 bg-transparent w-full text-start cursor-pointer"
>
  @if(item.iconName){
  <app-nav-icon-pair
    matListItemIcon
    class="routeIcon"
    [class.sub-item-icon]="!!item.subItemIcon"
    [icon]="item.iconName"
    [active]="isNavIconActive(item)"
    iconClass="routeIcon"
  />
  }
  <span class="hide-menu">{{ item.displayName | translate }}</span>

  @if (isOrdersHubRoute(item.route) && hubPendingCount() > 0) {
  <span>
    <span class="bg-error text-white px-2 py-1 item-chip font-medium rounded-full">{{
      hubPendingCount() > 99 ? '99+' : hubPendingCount()
    }}</span>
  </span>
  }

  @if(item.chip) {
  <span>
    <span class="{{ item.chipClass }} px-2 py-1 item-chip font-medium rounded-full">{{ item.chipContent }}</span>
  </span>
  }
</button>
}
}
<!-- children -->
@if(expanded) { @for(child of item.children; track child) {
<app-nav-item [item]="child" (click)="onSubItemSelected(child)" [depth]="depth + 1">
</app-nav-item>
} }
